<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import { DialogDescription, type DialogDescriptionProps } from 'reka-ui';
import { cn } from '@/lib/utils';
const props = defineProps<DialogDescriptionProps & { class?: HTMLAttributes['class'] }>();
const forwarded = computed(() => {
  const { class: _class, ...rest } = props;
  return rest;
});
</script>

<template>
  <DialogDescription
    v-bind="forwarded"
    :class="cn('text-sm leading-relaxed text-muted-foreground', props.class)"
    ><slot
  /></DialogDescription>
</template>
